import { useDosespotPatientInfoQuery } from '@/entities/rx';
import { DoseSpotWorklists } from '@/features/dosespot-worklists';
import { WorkspaceSection } from '@/shared/ui/primitives';
import { Alert, AlertDescription, AlertTitle } from '@/shared/ui/shadcn/alert';

interface PatientRxRequestsTabProps {
  readonly userId: string;
}

/** Workspace tab: pending DoseSpot refills and RxChanges for this patient. */
export function PatientRxRequestsTab({ userId }: PatientRxRequestsTabProps) {
  const dosespotPatientInfoQuery = useDosespotPatientInfoQuery(userId);
  const rawPatientId = dosespotPatientInfoQuery.data?.PatientId;
  const dosespotPatientId =
    typeof rawPatientId === 'number' && Number.isFinite(rawPatientId) ? rawPatientId : null;

  return (
    <div className="space-y-4" aria-label="Rx inbox">
      <WorkspaceSection
        title="Rx Inbox"
        description="Pending refill and RxChange requests routed to your prescriber for this patient."
      >
        {dosespotPatientInfoQuery.isLoading ? (
          <p className="text-sm text-muted-foreground">Loading DoseSpot patient info…</p>
        ) : dosespotPatientInfoQuery.isError ? (
          <Alert variant="destructive">
            <AlertTitle>Could not load DoseSpot patient info</AlertTitle>
            <AlertDescription>
              {dosespotPatientInfoQuery.error instanceof Error
                ? dosespotPatientInfoQuery.error.message
                : 'An unknown error occurred.'}
            </AlertDescription>
          </Alert>
        ) : dosespotPatientId === null ? (
          <p className="text-sm text-muted-foreground">
            This patient has not been registered with DoseSpot yet.
          </p>
        ) : (
          <DoseSpotWorklists patientId={dosespotPatientId} />
        )}
      </WorkspaceSection>
    </div>
  );
}
